import { ImageTransform } from '../image'

enum GoodsType {
  ONE_PRODUCT = 'one-product',
  TWO_PRODUCTS = 'two-products',
  THREE_PRODUCTS = 'three-products',
  FOUR_PRODUCTS = 'four-products',
  SIX_PRODUCTS = 'six-products',
}

enum GoodsItemLinkType {
  AFFILIATE = 'affiliate',
  DIRECT = 'direct',
}

interface GoodLink {
  id: number
  good_id: number
  link: string
  affiliate_url: string | null
  link_type: GoodsItemLinkType
  button: string
  sort: number
}

interface GoodsItem {
  title: string
  price: string
  caption: string
  alt: string
  source: string
  url: string
  label: string
  id: number
  image_transform_id: number | null
  imageTransform: ImageTransform | null
  links: GoodLink[]
}

type GoodsWidget = GoodsItem[]

export { GoodsType, GoodsItemLinkType }

export type { GoodsWidget, GoodsItem, GoodLink }
